import React, { Fragment, ReactNode } from "react";
import InstructLayout from "../../components/InstructSpace/InstructLayout/InstructLayout";

function InstructSpace() {
    return <Fragment></Fragment>;
}

InstructSpace.getLayout = (page: ReactNode) => (
    <InstructLayout>{page}</InstructLayout>
);

export default InstructSpace;
